import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { Facet } from 'engine/facets/Facet';
import { SpriteGroupFacet } from 'engine/facets/SpriteGroupFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { Activatable } from 'game/behaviors/Activatable';
import { FILTER_OUTLINE_ID } from 'game/defs/FilterOutline';
import { inGameUIClasses } from 'game/styles/inGameUI';
import { createElement } from 'react';
import { LabWallPanelSprite } from './LabWallSprite';

interface LabWallPanelProps {
  onHack: () => void,
}

class LabWallPanelBehavior extends Facet<LabWallPanelProps> {
  update(delta: number, engine: Engine) {
    if (engine.input.keyDown.KeyE) {
      if (this.entity.getFacet(Activatable)?.active) {
        this.props.onHack();
      }
    }
  }
}

export class LabWallPanelEntity extends Entity<LabWallPanelProps> {
  createFacets(props: LabWallPanelProps) {
    const sprite = create(SpriteGroupFacet, {
      children: [create(StaticSpriteFacet, { frame: LabWallPanelSprite, offset: [-65, -200] })],
    });
    let text: StaticSpriteFacet | null = null;
    return [
      sprite,
      create(LabWallPanelBehavior, props),
      create(ColliderFacet, { type: ColliderType.Box, size: [130, 70], offset: [-65, 0], trigger: true }),
      create(Activatable, {
        activate: (active, engine) => {
          sprite.props.filter = active ? `url(#${FILTER_OUTLINE_ID})` : undefined;

          if (active) {
            text = create(StaticSpriteFacet, {
              frame: createElement('text', {
                className: inGameUIClasses.activatedText,
                y: -220,
              }, '[e] Hack'),
            });
            this.addFacet(text, engine);
          } else if (text) {
            this.removeFacet(text);
          }
        },
      }),
    ];
  }
}
